import {useEffect, useState} from 'react';

import {formatDate, formatRelativeTime} from '../Classes/Tools';

import '../assets/css/quill.core.css';

import api from '../Classes/Api';
import DOMPurify from 'dompurify';

const Blog = (props) => {
	const [posts, setPosts] = useState([]);
	const [showDates, setShowDates] = useState(false);

	useEffect(() => {
		api.callApi('blog/posts', 'GET').then(data => {
			data.map((post) => {
				post.content = DOMPurify.sanitize(post.content);

				const dateCreated = new Date(post.date_created);
				post.date_created = formatDate(dateCreated);
				post.relative_time = formatRelativeTime(dateCreated);

				return post;
			});
			console.log('posts', data);
			setPosts(data);	
		});
	}, []);

	return (
		<div className="blog">
			{posts.map((post, index) => {
				return (
					<article key={index}>
						<h1>{post.title}</h1>
						<div onClick={({target}) => setShowDates(!showDates)}>
							{(showDates) ? (
								<>{post.date_created}</>
							) : (
								<>{post.relative_time}</>
							)}
						</div>


            			<div className="blogContent ql-editor" dangerouslySetInnerHTML={{ __html: post.body_html }} />
					</article>
				)
			})}
		</div>
	)
}


export default Blog;
